<template>
  <div class="relative bg-no-repeat bg-center" :class="size">
    <svg class="h-full w-full origin-center circle-animation" viewBox="25 25 50 50">
      <title>Loading...</title>
      <circle
        class="stroke-animation stroke-current"
        :class="color"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        :stroke-width="strokeWidth"
        stroke-miterlimit="1"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: string
    color?: string
    strokeWidth?: string
  }>(),
  {
    size: 'h-44 w-44',
    color: 'text-brand-300',
    strokeWidth: '1',
  },
)
</script>

<style scoped>
.circle-animation {
  animation: rotate 2s linear infinite;
}

.stroke-animation {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
</style>
